import React from "react";
import "./Contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";

const Contact = () => {
  return (
    <section /* data-aos="zoom-out" */ className="contact-section">
      <div
        data-aos="zoom-in"
        data-aos-duration="600"
        className="contact-overlay-card"
      >
        <h1>Contact Us</h1>

        <div className="contact-line"></div>

        <p className="contact-subtext">
          We are here to help your trucking business grow. Reach out to us
          anytime.
        </p>

        <div className="contact-details">
          <div className="contact-item">
            <div className="phone-no-div">
              <FontAwesomeIcon icon={faPhone} className="contact-icon" />
              <span>+1 (321) 808-9338</span>
            </div>
            <div className="email-div">
              <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
              <span>Info@livosol.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
